import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { MdAdd } from "react-icons/md";

function PlanHeader({ handleCreatePlan }) {
  return (
    <Box className="flex justify-between items-center mb-6">
      <Box>
        <Typography variant="h5" className="font-bold text-slate-900">
          Subscription Plans
        </Typography>
        <Typography variant="body2" className="text-slate-600 mt-1">
          Manage pricing tiers and plan configurations
        </Typography>
      </Box>
      <Button
        variant="contained"
        startIcon={<MdAdd />}
        onClick={handleCreatePlan}
        sx={{
          bgcolor: "#1F4FFF",
          textTransform: "none",
          px: 3,
          py: 1.5,
          borderRadius: "10px",
          fontWeight: 600,
          "&:hover": {
            bgcolor: "#1a40d9",
          },
        }}
      >
        Create Plan
      </Button>
    </Box>
  );
}

export default PlanHeader;
